const variantName = 'navigationV11'

export default {
  [variantName]: {
    // ?============================
    // ?======== Container =========
    // ?============================

    container: {
      position: 'fixed',
      backgroundColor: 'dark',
      width: '100%',
      top: '0px',
      left: '0px',
      zIndex: '1000',
      boxSizing: 'border-box',
      height: ['85px', '85px', '85px', ''],
      transition: 'all ease-in-out 0.4s',
      display: 'flex',
      transition: 'all ease-in-out 0.5s',
      alignItems: 'stretch',
      justifyContent: 'center',
      borderBottom: '1px solid lightgrey',
      '.smallNavMenu > .about': {
        display: 'none'
      }
    },
    containerScrolled: {
      variant: `${variantName}.container`
      // height: ['90px', '90px', '90px', 'unset'],
      // padding: ['0.5rem', '', '', '0.75rem'],
      // backgroundColor: 'black',
    },

    // ?============================
    // ?=======  Nav Logos =========
    // ?============================

    logoLocationContainer: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0.25rem 1rem',
      height: '100%',
      textAlign: 'center',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      '.locationSwitcher': {
        display: 'none'
      }
    },

    logo: {
      zIndex: '2000',
      transition: 'all ease-in-out 0.4s',
      justifyContent: 'center',

      img: {
        opacity: '0.85',
        maxHeight: ['55px'],
        ':hover': {
          opacity: '1'
        }
      }
    },
    logoScrolled: {
      variant: `${variantName}.logo`
    },

    navMenuLogo: {
      img: {
        maxHeight: ['55px', '', '', '']
      },
      marginBottom: ['2rem', '', '', '1.5rem']
      // position: ['', '', '', 'absolute'],
      // left: ['', '', '', '2rem'],
      // width: ['', '', '', '40%'],
    },

    // ?============================
    // ?=======  Hamburger =========
    // ?============================

    hamburger: {
      position: 'relative',
      display: ['flex', 'flex', 'flex', ''],
      zIndex: '2002',
      alignSelf: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '35px',
      height: '25px',
      cursor: 'pointer',
      margin: ['0 0.5rem 0 auto', '', '', '0rem 0.75rem'],
      minWidth: '30px',
      position: 'absolute',
      right: '0',
      div: {
        alignSelf: 'flex-end',
        transition: 'all ease-in-out 0.3s',
        height: '4px',
        width: '100%',
        backgroundColor: 'light',
        borderRadius: '10px'
      }
    },
    hamburgerOpen: {
      variant: `${variantName}.hamburger`,
      height: 'unset',
      div: {
        position: 'absolute',
        boxShadow: 'none',
        transition: 'all ease-in-out 0.3s',
        height: '4px',
        width: '100%',
        backgroundColor: 'light',
        borderRadius: '10px'
      },
      '& > div:nth-of-type(1)': {
        transform: 'rotate(135deg) '
      },
      '& > div:nth-of-type(2)': {
        transform: 'rotate(-135deg)'
      }
    },

    // ?============================
    // ?========  Nav Menu =========
    // ?============================

    navMenu: {
      position: ['absolute', 'absolute', 'absolute'],
      margin: '0px',
      boxSizing: 'border-box',
      justifyContent: ['flex-start', 'flex-start', 'flex-start'],
      height: ['100vh', '100vh', '100vh', 'unset'],
      backgroundColor: ['background', 'background', 'background'],
      top: '0px',
      zIndex: '2000',
      width: ['100%', '100%', '50%', '30%'],
      height: '100vh',
      minWidth: '250px',
      left: '-120%',
      transition: 'all ease-in-out 1.2s',
      padding: ['1rem', '', '', '2rem'],
      alignItems: ['center', 'center', 'center', 'flex-end'],
      textAlign: 'center',
      display: 'flex',
      flexDirection: ['column', 'column', 'column'],
      // overflow: 'hidden',
      listStyleType: 'none'
    },

    // when nav is open it uses this variant
    navMenuOpen: {
      variant: `${variantName}.navMenu`,
      left: '0%',
      ' > .about': {
        display: 'none'
      },
      '.navItemDropdownMenu': {
        position: 'static',
        backgroundColor: 'transparent',
        padding: '0rem',
        borderTop: '1px solid lightgrey',
        alignItems: 'flex-end',
        justifyContent: 'fcenter',
        flexDirection: ['column', '', '', 'column'],
        width: 'fit-content',
        '#siena-restaurantsDropdown': {
          display: 'none'
        },
        li: {
          padding: '0.5rem 0rem',
          a: {
            fontSize: ['0.85rem', '', '', '1rem', '1.1rem'],
            opacity: '0.8',
            color: 'light',
            ':hover': {
              color: 'primary'
            }
          }
        }
      },
      '.aboutDropdownNavItem': {
        justifyContent: 'flex-end'
        // a: {

        // }
      }
    },

    navItem: {
      // margin: ['0.5rem', '0.75rem', '', '0.5rem'],
      // height: '100%',
      opacity: '0.8',
      display: 'flex',
      alignItems: 'center',
      zIndex: '100',
      listStyleType: 'none',
      padding: ['.65rem 0rem', '', '', ''],
      color: 'light',
      a: {
        fontFamily: 'heading',
        fontSize: ['1rem', '', '', '1.1rem', '1.2rem'],
        textTransform: 'uppercase',
        fontWeight: '400',
        letterSpacing: '2px',
        textDecoration: 'none',
        ':hover': {
          color: 'secondary'
        }
      }
    },

    smallNavMenuLeft: {
      display: ['none', '', '', 'flex'],
      justifyContent: 'flex-end',
      flex: '1',
      '.navItem': {
        height: '100%',
        padding: ['0.5rem', '', '', ''],
        a: {
          fontSize: ['0.9rem', '0.9rem', '0.9rem', '0.8rem', '0.9rem'],
          textAlign: 'center'
        }
      }
    },

    smallNavMenuRight: {
      display: ['none', '', '', 'flex'],
      justifyContent: 'flex-start',
      flex: '1',

      // '> li:nth-of-type(3)': {
      //   order: 4,
      //   a: {
      //     borderRadius: '3px',
      //     color: 'primary',
      //     border: '2px solid',
      //     borderColor: 'primary',
      //     paddingX: '24px',
      //     paddingY: 3,
      //     textAlign: 'center',

      //     '&:hover': {
      //       backgroundColor: 'primary',
      //       color: 'white',
      //       transition: 'all .3s',
      //     },
      //   },
      // },

      '.navItem': {
        height: '100%',
        padding: ['0.5rem', '', '', ''],
        a: {
          fontSize: ['0.9rem', '0.9rem', '0.9rem', '0.8rem', '0.9rem'],
          textAlign: 'center',
          color: 'primary'
        }
      }
    },

    smallNavHeading: {
      fontSize: '1rem',
      marginBottom: '0.5rem',
      fontWeight: '400'
    },

    navBlock: {
      backgroundColor: ['background', 'background', 'background'],
      top: '0px',
      zIndex: '1000',
      width: ['100%', '100%', '50%', '30%'],
      height: '100vh',
      zIndex: '2000',
      minWidth: '250px',
      left: '-120%',
      transition: 'all ease-in-out 1.2s',
      opacity: '0.85',
      position: ['absolute', 'absolute', 'absolute']
    },

    navBlockOpen: {
      variant: `${variantName}.navBlock`,
      left: ['100%', '100%', '50%', '30%']
    },

    // ?==========================
    // ?====  Dropdown Styles ====
    // ?==========================

    navItemDropdown: {
      alignItems: 'inherit',
      fontFamily: 'inherit',
      justifyContent: 'inherit',
      position: 'relative',
      cursor: 'pointer',
      fontWeight: 300
    },

    subNavItemDropdown: {
      variant: `${variantName}.navItem`,
      padding: '1.5rem !important',
      margin: ['0rem', '0rem', '0rem', '0rem'],
      whiteSpace: 'nowrap',
      color: 'white',
      textTransform: 'uppercase',
      fontWeight: 300,
      a: {
        ':hover': {
          color: 'white',
          textDecoration: 'underline'
        }
      },
      ':hover': {
        color: 'white'
      }
    },

    navItemDropdownMenu: {
      padding: '0rem',
      textShadow: '0px 0px 30px rgb(122 122 122 / 79%)',
      position: ['', '', '', 'fixed'],
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: ['column', '', '', 'row'],
      width: ['100%', '', '', '100vw'],
      left: '0rem',
      backgroundColor: 'primary',
      display: ['', '', '', 'flex'],
      fontWeight: 300
    },

    // ?==========================
    // ?=====  Nav Widgets  ======
    // ?==========================

    locationSwitcher: {
      backgroundColor: '',
      zIndex: '2000',
      alignSelf: 'flex-start',
      marginTop: '0.5rem',
      button: {
        backgroundColor: 'unset',
        borderTop: '1px solid',
        borderRadius: '0px'
      },
      '.popUp': {
        transform: ['', '', '', 'translateX(-45%)']
      },
      '.popUp .content': {
        backgroundColor: 'rgb(255 255 255 / 74%)'
      }
    },

    socialIconsContainerDesktop: {
      display: ['none', '', '', 'flex'],
      padding: '0.5rem 1rem',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      margin: ['', '', '', '0 auto 0 0'],
      a: {
        display: 'flex',
        textAlign: 'center',
        padding: '0.5rem',
        alignItems: 'center',
        transition: 'all ease-in-out 0.5s',
        ':hover': {
          transform: 'scale(1.5)',
          svg: {
            path: { fill: 'secondary' }
          }
        }
      }
    },

    phoneContainerDesktop: {
      display: ['none', '', '', 'block'],
      borderRight: 'solid 1px',
      borderColor: 'secondary',
      paddingRight: '0.75rem',
      a: {
        transition: 'all ease-in-out 0.5s',
        ':hover': {
          color: 'secondary',
          fontSize: '1.1rem'
        }
      }
    },

    phoneSocialContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: ['center', '', '', 'flex-end'],
      flexDirection: ['row', '', '', 'column'],
      width: '100%',
      maxWidth: '450px',
      svg: {
        path: { fill: 'dark' }
      }
    },

    phoneContainer: {
      padding: '0.5rem',
      width: 'calc(50% - 1rem)',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      border: '1px solid',
      borderColor: 'light',
      margin: ['0.5rem', '', '', '0.5rem 0rem'],
      a: {
        display: 'flex',
        padding: '0.5rem',
        alignItems: 'center',
        fontSize: '0.8rem',
        textAlign: 'center',
        justifyContent: 'center',
        svg: {
          marginRight: '0.25rem'
        }
      }
    },

    socialIconsContainer: {
      padding: '0.5rem',
      flexDirection: 'column',
      alignItems: ['center', '', '', 'flex-end'],
      width: 'calc(50% - 1rem)',
      textAlign: ['center', '', '', 'right'],
      border: '1px solid',
      borderColor: 'light',
      margin: ['0.5rem', '', '', '0.5rem 0rem'],
      a: {
        display: 'flex',
        textAlign: 'center',
        padding: '0.5rem',
        alignItems: 'center'
      }
    }
  }
}
